import { Navigate } from "react-router-dom";
import { useFirebase } from "../contexts/FirebaseContext";

const PrivateRoute = ({ children }) => {
	const { user, loading } = useFirebase();

	if (loading) return null; // or spinner

	return user ? children : <Navigate to="/c/login" />;
};

export default PrivateRoute;
